import { render, staticRenderFns } from "./type-access-rules-link.vue?vue&type=template&id=8f47c2ee&"
import script from "./type-access-rules-link.vue?vue&type=script&lang=js&"
export * from "./type-access-rules-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports